
























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PriceDisplay extends Vue {
    @Prop() regularPrice!: number | string;
    @Prop() campaignPrice!: number | string | null;

    get currency() {
        return window.__litium.preloadState.cart.currency || ':-';
    }
    get regularPriceNum(): number {
        return this.parsePrice(this.regularPrice);
    }

    get campaignPriceNum(): number {
        return this.parsePrice(this.campaignPrice || 0);
    }

    parsePrice(price: number | string) {
        if (typeof price === 'number') {
            return price;
        }
        return parseInt(price.replace(/\s|:-/g, ''));
    }

    get mainPrice() {
        return this.campaignPriceNum || this.regularPriceNum;
    }
    get saveAmmount() {
        return this.regularPriceNum - this.campaignPriceNum;
    }
}
